import React from 'react';
import './index.scss';

function Info() {
  return (
    <div className="section info" id="info">
        <div className="anchor-wrapper">
            <div className="anchor"/>
        </div>
        <div className="inner">
            <h1>info</h1>
            <div className="content">
                Creative coder making user experiences for the web.<br/>
                Mostly working with React.js and Nextjs.<br/>
                Coded the first website back in the 90s.
            </div>
        </div>
    </div>
  );
}

export default Info;
